module.exports = __webpack_public_path__ + "fonts/Inter-600-latin-ext62.1ad231a.woff2";